export default __webpack_public_path__ + "static/ford-transit-db3dd3c12aca635553e51f18b003e0e5.jpg";